//  function sum(...numbers){
//   return numbers.reduce((asc , next) => asc + next)
// }
//
//  function max(ary){
//  return  Math.max(...ary);
// }
//
//  function minSalary(ary){
//   let list = ary.map((o) => o.salary)
//   return Math.min(...list)
// }
import moment from 'moment'
import axios from '../utils/axiosinstance'
// import axios from 'axios'
function formatDate (val,time = false) {
  val = val || ''
  let d = new Date(val.substring(0, 10))
  if (isNaN(d.getDate())) {
    return ''
  } else {
    let day = d.getDate()
    let month = d.getMonth() + 1
    day = day < 10 ? `0${day}` : day
    month = month < 10 ? `0${month}` : month
    if (time){
      return `${day}.${month}.${d.getFullYear()}  ${val.substring(11,13)}:${val.substring(14,16)} Uhr`;
    }else {
      return `${day}.${month}.${d.getFullYear()}`;
    }
  }
}

function formatTimeUhr (val) {
  if (!val) {
    return ''
  }
  return val.substr(11, 5)
}

function formatDateHash (val) {
  val = val || ''
  let d = new Date(val.substr(0, 10))
  if (isNaN(d.getDate())) {
    return ''
  } else {
    let day = d.getDate()
    let month = d.getMonth() + 1
    day = day < 10 ? `0${day}` : day
    month = month < 10 ? `0${month}` : month
    return `${d.getFullYear()}-${month}-${day}`
  }
}

function formatAsInputDate (val) {
  return moment(val, 'DD.MM.YYYY').format('YYYY-MM-DD')
}

function todayDate () {
  return moment(new Date()).format('YYYY-MM-DD')
}

async function getFile (params) {
  let photo = null
  const jwt = localStorage.getItem('jwt');
  await fetch(`${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${params.projectId}&id=${params.photoId}&token=${jwt}`,
    {
      headers: {
        apitoken: localStorage.apikey,
        deviceid: localStorage.deviceid
      }
    }
  ).then(response => response.blob())
    .then(response => {
      photo = response
    }).catch(error => { console.log(error) })

  return photo
}

function getPathVariable(variable) {
  var path = location.pathname;

  var parts = path.substr(1).split('/'), value;

  while(parts.length) {
    if (parts.shift() === variable) value = parts.shift();
    else parts.shift();
  }

  return value;
}

async function getonlinestate () {

  console.log('getonlinestate', window.location.pathname)
  if(window.location.pathname == '/login' || window.location.pathname == '/') {
    setTimeout(function () {
      getonlinestate()
    }, 60000)
    return
  }

  // await axios.get(`${process.env.VUE_APP_GET_METHOD_URL}isonline&token=${localStorage.sessiontoken}`,
  const jwt = localStorage.getItem('jwt');
  await axios.get(`${process.env.VUE_APP_GET_METHOD_URL}isonline&token=${jwt}`,
    {
      headers: {
        apitoken: localStorage.apikey,
        deviceid: localStorage.deviceid,
        accept: 'application/json'
      }
    }
  ).then(response => {
    if (response.status === 200) {

      if(response.data.status == '0') {
        jQuery('#loginexpiredmodal').modal({
          show: true
        });
      }


      // console.log(response)
      setTimeout(function () {
        getonlinestate()
      }, 60000)
    }
  }).catch(error => {
    // alert('Ihre Sitzung ist abgelaufen. Sie müssen sich neu anmelden.')
    jQuery('#loginexpiredmodal').modal({
      show: true
    });
    // window.location = '/'
    console.log('Not logged in anymore')
    console.log(error)
  })
}

async function readFile (file) {
  let reader = new FileReader()
  await new Promise((resolve, reject) => {
    reader.onload = resolve
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
  return reader.result
}

async function getPhotoFile (payload) {
  const file = await getFile(payload)
  return await readFile(file)
}

function setAspectRatio () {
  let els = document.getElementsByClassName('innerdoc')
  for (let i = 0; i < els.length; i++) {
    let width = els[i].offsetWidth
    els[i].style.height = `${width * 1.4}px`
  }
}

export { formatDate, getPhotoFile, formatAsInputDate, todayDate, setAspectRatio, formatDateHash, formatTimeUhr}
// export { sum , maxSalary, minSalary, max }

document.addEventListener('gesturestart', function (e) {
  e.preventDefault()
  // special hack to prevent zoom-to-tabs gesture in safari
  console.log('gestureStart')
})

document.addEventListener('gesturechange', function (e) {
  e.preventDefault()
  // special hack to prevent zoom-to-tabs gesture in safari
  console.log('gestureChange')
})

document.addEventListener('gestureend', function (e) {
  e.preventDefault()
  // special hack to prevent zoom-to-tabs gesture in safari
  console.log('gestureEnd')
})

document.addEventListener('wheel', event => {
  const { ctrlKey } = event
  if (ctrlKey) {
    console.log('eventListenerWheel')
    event.preventDefault()
  }
}, { passive: false })

$(document)
  .ready(function () {
    // Send online check

    getonlinestate();

  })
  .on('keyup', '.enterblur', function (e) {
    if (e.which == 13) {
      $(this).blur()
    }
  })



// WEBPACK FOOTER //
// ./src/components/common.js